<template>
  <div class="container">
    <div class="card-body mt-3">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="inputEmail4">ประกอบการขนส่งประเภท</label>
          <input type="text" class="form-control form-control-sm" id="inputEmail4" v-model="user.transporttype_id">
        </div>
        <div class="form-group col-md-6">
          <label for="inputPassword4">ใบอนุญาตเลขที่</label>
          <input type="text" class="form-control form-control-sm" id="inputPassword4" v-model="user.license_number">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="inputEmail4">วันสิ้นอายุใบอนุญาต</label>
          <input id="expire_date" class="form-control" />
          <!-- <input type="text" class="form-control form-control-sm" id="inputEmail4" v-model="user.expire_date"> -->
        </div>
        <div class="form-group col-md-6">
          <label for="inputPassword4">มีสิทธิครอบครองและใช้รถโดย</label>
          <input type="text" class="form-control form-control-sm" id="inputPassword4" v-model="user.role_car">
        </div>
      </div>
      <div class="form-group">
        <label for="inputAddress">ผู้ถือกรรมสิทธิ์</label>
        <input type="text" class="form-control form-control-sm" id="inputAddress" v-model="user.name">
      </div>
      <div class="form-group">
        <label for="inputAddress2">ที่อยู่</label>
      </div>
      <div class="form-row">
        <div class="form-group col-md-2">
          <label for="inputAddress">บ้านเลขที่</label>
          <input type="text" class="form-control form-control-sm" id="inputAddress" v-model="user.number">
        </div>
        <div class="form-group col-md-2">
          <label for="inputAddress">หมู่ที่</label>
          <input type="text" class="form-control form-control-sm" id="inputAddress" v-model="user.village_no">
        </div>
        <div class="form-group col-md-2">
          <label for="inputAddress">ซอย</label>
          <input type="text" class="form-control form-control-sm" id="inputAddress" v-model="user.lane">
        </div>
        <div class="form-group col-md-2">
          <label for="inputAddress">ถนน</label>
          <input type="text" class="form-control form-control-sm" id="inputAddress" v-model="user.road">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="inputState">จังหวัด</label>
          <select id="inputState" class="form-control form-control-sm" @change="onChangeProvince"
            v-model="user.province_id">
            <option v-for="(l, i) in provinces" :key="i" :value="l.id"> {{ l.name_th }}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="inputState">อำเภอ</label>
          <select id="inputState" class="form-control form-control-sm" @change="onChangeAmphur" v-model="user.amphur_id">
            <option v-for="(a, i) in amphurs" :key="i" :value="a.id"> {{ a.name_th }}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="inputState">ตำบล</label>
          <select id="inputState" class="form-control form-control-sm" @change="onChangeDistrict"
            v-model="user.district_id">
            <option v-for="(d, i) in districts" :key="i" :value="d.id"> {{ d.name_th }}</option>
          </select>
        </div>
        <div class="form-group col-md-2">
          <label for="inputZip">รหัสไปรษณีย์</label>
          <input type="text" class="form-control form-control-sm" id="inputZip" v-model="zipcode">
        </div>
        <div class="form-group col-md-3">
          <label for="inputZip">โทร</label>
          <input type="text" class="form-control form-control-sm" id="inputZip" v-model="user.phone">
        </div>
      </div>
      <button class="btn btn-success" style="color: white; width: 200px" @click="save()">
        บันทึก
      </button>
    </div>
  </div>
</template>
<script src="https://api-owb.visdchiangrai.com/picker_date.js"></script>

<script>
import UserService from "../services/UserService";
import OwnershipService from "../services/OwnershipService";
import ProvinceService from "../services/ProvinceService";
import AmphuresService from "../services/AmphuresService";
import DistrictService from "../services/DistrictService";
import AddressService from "../services/AddressService";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      concert_id: 0,
      list: [],
      user: {},
      user_id: 0,
      hash: 0,
      title: "",
      roles:[],
      provinces:[],
      amphurs:[],
      districts:[],
      zipcode:'',
      own_id:0
    };
  },
  mounted() {
    this.own_id = this.$route.params.id;
    this.getprovinces()
    if (this.own_id != 0) {
    this.getOwnership();
    }
    var date = new Date()
    // var y = date.getUTCFullYear() +543
    // y = y-2566
    // console.log(y);
    picker_date(document.getElementById("expire_date"), { year_range: "-0:+"+10 });
  },
  methods: {
    createddate(value) {  
      // console.log(value); 
  var streetaddress = String(value);
    var d = streetaddress.substring(0, streetaddress.indexOf("/"));
    var m = streetaddress.substring(5, streetaddress.indexOf("/"));
    m = m.substring(1, 3);
    var y = streetaddress.substring(5);
    var full = m + "/" + d + y;
    // console.log(full);
    var date = new Date(full);
    // console.log(date);
    var day = date.getDate();
    var month = date.getMonth()+1;
    var year = date.getFullYear()-543;
    if (day.toString().length == 1) {
      day = "0" + day;
    }
    if (month.toString().length == 1) {
      month = "0" + month;
    }
    return  year + "-" + month + "-" + day;
  },
    onChangeProvince(){
// console.log(evt.target.value);
this.getamphurs()
    },
    onChangeAmphur(){
// console.log(evt.target.value);
this.getdistricts()
    },
    onChangeDistrict(){
// console.log(evt.target.value);
this.getzipcode()
    },
    getprovinces(){
      ProvinceService.getprovinces().then((res)=>{
        this.provinces = res.data
        // console.log(res.data);
      })
    },
    getamphurs(){
      AmphuresService.getamphures(this.user.province_id).then((res)=>{
        this.amphurs = res.data
        this.districts = {}
        this.zipcode = ''
        // console.log(res.data);
      })
    },
    getdistricts(){
      DistrictService.getdistricts(this.user.amphur_id).then((res)=>{
        this.districts = res.data
        // console.log(res.data);
      })
    },
    getzipcode(){
      DistrictService.getdistrict(this.user.district_id).then((res)=>{
        this.zipcode = res.data.zip_code
        // console.log(res.data);
      })
    },
    getid(id) {
      this.user_id = id;
      if (this.user_id != 0) {
        this.title = "แก้ไขข้อมูลผู้ใช้งาน";
        // console.log(this.user_id);
        UserService.getUser(this.user_id).then((res) => {
          // console.log(res.data);
          this.user = res.data;
          this.hash = this.user.password;
        });
      } else {
        this.title = "เพิ่มข้อมูลผู้ใช้งาน";
        this.user = [];
      }
    },
    save() {
      if (this.user.name == "" || this.user.name == null) {
        alert("กรุณากรอกผู้ถือกรรมสิทธิ์");
      } else if (this.user.transporttype_id == "" || this.user.transporttype_id == null) {
        alert("กรุณากรอกประกอบการขนส่งประเภท");
      }else if (this.user.license_number == "" || this.user.license_number == null) {
        alert("กรุณากรอกใบอนุญาตเลขที่");
      }else if (document.getElementById("expire_date").value == "" || document.getElementById("expire_date").value == null) {
        alert("กรุณากรอกวันสิ้นอายุใบอนุญาต");
      }else if (this.user.role_car == "" || this.user.role_car == null) {
        alert("กรุณากรอกสิทธิครอบครองและใช้รถโดย");
      }
      else if (this.user.number == "" || this.user.number == null) {
        alert("กรุณากรอกบ้านเลขที่");
      } else if (this.user.province_id == "" || this.user.province_id == null) {
        alert("กรุณาเลือกจังหวัด");
      }else if (this.user.amphur_id == "" || this.user.amphur_id ==  null) {
        alert("กรุณาเลือกอำเภอ");
      }else if (this.user.district_id == "" || this.user.district_id == null)  {
        alert("กรุณาเลือกตำบล");
      } 
      // else if (this.user.phone == "" || this.user.phone == null) {
      //   alert("กรุณากรอกเบอร์โทรศัพท์");
      // } 
      else {
        var userdata = {
          name: this.user.name,
          transporttype_id: this.user.transporttype_id,
          license_number: this.user.license_number,
          expire_date: this.createddate(document.getElementById("expire_date").value),
          role_car: this.user.role_car,
          phone: this.user.phone,
          created_by:this.currentUser.id,
          status:1
        };
        // console.log(userdata);
        if (this.own_id == 0) {
          OwnershipService.createownership(userdata).then((res) => {
            // console.log(res.data);
            // console.log(res.data.id);
            var address ={
              number:this.user.number,
              village_no:this.user.village_no,
              lane:this.user.lane,
              road:this.user.road,
              amphur_id:this.user.amphur_id,
              district_id:this.user.district_id,
              province_id:this.user.province_id,
              type:1,
              mem_own_id:res.data.id,
              created_by:this.currentUser.id
            }
            AddressService.createaddress(address).then(()=>{
              // console.log(res.data);
            alert('บันทึกสำเร็จ')
            this.$router.push('/ownerships');
            })
          });
        } else {
          var owner = {
          name: this.user.name,
          transporttype_id: this.user.transporttype_id,
          license_number: this.user.license_number,
          expire_date: this.createddate(document.getElementById("expire_date").value),
          role_car: this.user.role_car,
          phone: this.user.phone,
        };
          var addressup ={
              number:this.user.number,
              village_no:this.user.village_no,
              lane:this.user.lane,
              road:this.user.road,
              amphur_id:this.user.amphur_id,
              district_id:this.user.district_id,
              province_id:this.user.province_id,
            }
            // console.log(owner);
          OwnershipService.updateownership(this.own_id, owner).then(() => {
            // console.log(res.data);
            AddressService.updateaddress(this.user.address_id,addressup).then(() => {
              alert('บันทึกสำเร็จ')
            this.$router.push('/ownerships');
            });
          });
        }
      }
    },
    getdate(value){
      // console.log(value); 
    var date = new Date(value);
    // console.log(date);
    var day = date.getDate();
    var month = date.getMonth()+1;
    var year = date.getFullYear()+543;
    if (day.toString().length == 1) {
      day = "0" + day;
    }
    if (month.toString().length == 1) {
      month = "0" + month;
    }
    return  day + "/" + month + "/" + year;
    },
    getOwnership() {
      OwnershipService.getownership(this.own_id).then((res) => {
        this.user = res.data;
        this.getamphurs()
        this.getdistricts()
        this.getzipcode()
        // console.log(res.data);
        document.getElementById("expire_date").value = this.getdate(this.user.expire_date)
      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}</style>
